var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIconColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3176_32508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 0.595703H6.25C2.79822 0.595703 0 3.28199 0 6.5957V23.3957C0 26.7094 2.79822 29.3957 6.25 29.3957H23.75C27.2018 29.3957 30 26.7094 30 23.3957V6.5957C30 3.28199 27.2018 0.595703 23.75 0.595703Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 9.1157C8.125 7.72395 9.27927 6.5957 10.7031 6.5957H16.8663C17.55 6.5957 18.2057 6.8612 18.6892 7.3338L21.1199 9.70968C21.6034 10.1823 21.875 10.8232 21.875 11.4916V20.8757C21.875 22.2675 20.7207 23.3957 19.2969 23.3957H10.7031C9.27927 23.3957 8.125 22.2675 8.125 20.8757V9.1157ZM10.7031 8.2757C10.2285 8.2757 9.84375 8.65179 9.84375 9.1157V20.8757C9.84375 21.3396 10.2285 21.7157 10.7031 21.7157H19.2969C19.7715 21.7157 20.1562 21.3396 20.1562 20.8757V11.4916C20.1562 11.2688 20.0656 11.0552 19.9045 10.8976L17.4739 8.52174C17.3126 8.36422 17.0941 8.2757 16.8663 8.2757H10.7031ZM11.5625 13.3157C11.5625 12.8518 11.9473 12.4757 12.4219 12.4757H17.5781C18.0527 12.4757 18.4375 12.8518 18.4375 13.3157C18.4375 13.7796 18.0527 14.1557 17.5781 14.1557H12.4219C11.9473 14.1557 11.5625 13.7796 11.5625 13.3157ZM11.5625 16.6757C11.5625 16.2118 11.9473 15.8357 12.4219 15.8357H15.8594C16.334 15.8357 16.7188 16.2118 16.7188 16.6757C16.7188 17.1396 16.334 17.5157 15.8594 17.5157H12.4219C11.9473 17.5157 11.5625 17.1396 11.5625 16.6757Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3176_32508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIconColor);
export default __webpack_public_path__ + "static/media/docIconColor.0e5ac3ae962cf46360a7bff74959b22a.svg";
export { ForwardRef as ReactComponent };